import $ from 'jquery';

/**
 * Danger buttons
 */
$(document.body).on('click',  '.js-btn-danger', function(e){
	const confirmationMessage = $(this).data("message") || "Are you sure?"
	const confirmation = confirm(confirmationMessage)
	if(!confirmation) {
		e.preventDefault()
		e.stopPropagation()
		return false
	}
});

/**
 * Confirm buttons
 */
$(document.body).on('click',  '.js-btn-confirm', function(e){
	const $this = $(this);
	const $targetEl = $this.data("confirm-target")
	const targetValue = $this.data("confirm-target-value")
	if(!$targetEl.val() !== targetValue) {
		e.preventDefault()
		e.stopPropagation()
		return false
	}
});